/*
 * @Date: 2023-09-04 15:36:23

 */
export const navBarInfo = {
	backFlag: true,
  langCode_title: 'aMap_title'
};